// extracted by mini-css-extract-plugin
export default {"divider":"divider--ZbAfO","item":"item--_7LTf","itemText":"itemText--_i685","primary":"primary--o1Xpv"};